import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Shifts } from 'src/models/shifts/shifts';
import { environment } from 'src/environments/environment.prod';

const SERVICE_NAME =  environment.SERVICE_NAME;

@Injectable({
  providedIn: 'root'
})

export class ShiftsService {

  constructor(private http: HttpClient) {
  }


  
  getShiftsPag(pagination?: any): Observable<Shifts> {
    return this.http.post<any>(SERVICE_NAME + 'listShifts', pagination);
  }

  getShifts(): Observable<Shifts[]> {
    return this.http.get<any>(SERVICE_NAME + 'listShifts');
  }

  getShiftsMaster(): Observable<Shifts[]> {
    return this.http.get<any>(SERVICE_NAME + 'listShiftMaster');
  }

  createShifts(shift?: any): Observable<Shifts[]> {
    return this.http.post<any>(SERVICE_NAME + 'createShift', shift);
  }

  viewShifts(shiftId?: string): Observable<Shifts> {
    return this.http.post<any>(SERVICE_NAME + 'getShiftById', shiftId);
  }

  updateShifts(shift?: any): Observable<Shifts[]> {
    return this.http.put<any>(SERVICE_NAME + 'updateShift', shift);
  }

  updateEmployeeShift(shift?: any): Observable<Shifts[]> {
    return this.http.put<any>(SERVICE_NAME + 'updateEmployeeShift', shift);
  }

  deleteShifts(shift?: any): Observable<Shifts> {
    return this.http.post<any>(SERVICE_NAME + 'deleteShift', {id: shift});
  }


}
